import { useSelector } from 'react-redux'
import { StyledLoading } from './style';

import loadingIcon from '../../assets/loading.svg';

const Loading = (props) => {
  const loading = useSelector((state) => state.loading);

  if(loading.show){
    return(
      <StyledLoading>
        <div className="icon">
          <img src={loadingIcon} alt={loading.message} />
        </div>

        <div className="text">{loading.message}</div>
      </StyledLoading>
    )
  }
  else return null;
}

export default Loading;
